<template>
  <v-dialog persistent width="400" v-model="visible" @keydown.esc="close">
    <v-form ref="form">
      <v-card :loading="loading">
        <v-card-title>清理关键词记录</v-card-title>
        <v-card-text>
          <v-text-field label="ASIN" v-model="keyword.asin" :rules="rules.required"/>
          <v-row>
            <v-col cols="6">
              <v-text-field type="date" label="记录时间 (开始)" v-model="keyword.beginTime" :rules="rules.required"/>
            </v-col>
            <v-col cols="6">
              <v-text-field type="date" label="记录时间 (结束)" v-if="endTimeEnabled" v-model="keyword.endTime"/>
              <v-switch v-else v-model="endTimeEnabled" label="记录时间 (结束)"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text color="error" :loading="loading" @click="clear">清除</v-btn>
          <v-btn text color="grey" @click="close">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: "KeywordCleanDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      endTimeEnabled: false,
      keyword: {},
      rules: {
        required: [
            v => !!v || "该项不得为空."
        ]
      }
    }
  },
  methods: {
    clear() {
      this.loading = true;

      this.$axios.delete(`/keyword/${this.keyword.asin}`, {
        data: this.keyword
      }).then(
          () => {
            this.$emit("reload");
            this.close();
          }
      );
    },
    reset() {
      this.keyword = {
        asin: null,
        beginTime: null,
        endTime: null,
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        this.reset();
      }
    }
  }
}
</script>

<style scoped>

</style>